export default "__VITE_ASSET__DPqEqnEz__"